import React from 'react';
import { ElfsightWidget } from 'react-elfsight-widget';

import usePlugin from 'src/queries/usePlugin';

const Plugin = () => {
  const { queryPlugin } = usePlugin();

  return (
    <div className="container_calendar_plugin">
      {queryPlugin?.data?.data?.item?.calendar && (
        <div className="calendar_plugin">
          <ElfsightWidget widgetID={queryPlugin?.data?.data?.item?.calendar} />
        </div>
      )}
    </div>
  );
};

export default Plugin;
